//@flow
import * as Immutable from 'immutable';
import _ from 'lodash';

export const immutableModelDiff = (model1, model2) => {
    // Unused, only for debug purposes
    model1.forEach((value, key) => {
        const model2Value = model2.get(key);
        if (value !== model2Value) {
            // eslint-disable-next-line no-console
            console.log('change in value', key, value, model2Value);
        }
    });
    model2.forEach((value, key) => {
        if (!model1.has(key)) {
            // eslint-disable-next-line no-console
            console.log('added in value', key, value);
        }
    });
};

export const mergeDeepWithRemovalForModelMaps = (map1, map2) => {
    let mergedMap = map1;
    map1.forEach((value, key) => {
        const map2Value = map2.get(key);
        if (map2Value) {
            // merge the values using ImmutableModel's mergeDeep
            const mergedValue = value.mergeDeep(map2Value);
            if (mergedValue !== value) {
                mergedMap = mergedMap.set(key, mergedValue);
            }
        } else {
            //The key is not in map2, delete it
            mergedMap = mergedMap.delete(key);
        }
    });

    map2.forEach((value, key) => {
        if (!mergedMap.has(key)) {
            // If mergedMap does not have an item from map2, add it to it
            mergedMap = mergedMap.set(key, value);
        }
    });

    return mergedMap;
};

export const mergeDeepWithRemoval = (map1, map2) => {
    var mergedMap = map1.mergeDeep(map2);

    var keysNotInSecondMap = [];
    map1.mapKeys(previousKey => {
        if (!map2.get(previousKey)) {
            keysNotInSecondMap.push(previousKey);
        }
    });

    if (!keysNotInSecondMap.length) {
        //If there is nothing to be removed, return now, since withMutations would create a new object
        return mergedMap;
    }

    return mergedMap.withMutations(map => {
        keysNotInSecondMap.forEach(keyTobeDeleted => {
            map.delete(keyTobeDeleted);
        });
    });
};

export const mapFromList = (list, key) => {
    var map = Immutable.OrderedMap();
    return map.withMutations(map => {
        list.forEach(item => {
            if (_.isFunction(key)) {
                var keyValue = key(item);
                map.set(keyValue, item);
            } else if (_.isArray(key)) {
                map.set(item.getIn(key), item);
            } else {
                map.set(item.get(key), item);
            }
        });
        return map;
    });
};

export const immutableArgsResolver = (...args) => {
    var hashCode = '';
    for (var i in args) {
        var arg = args[i];
        hashCode += arg.hashCode();
    }
    return hashCode;
};

export const without = (
    firstArray: Immutable.List<string>,
    secondArray: Immutable.List<string>
): Immutable.List<string> => {
    return firstArray.filter(tag => {
        return secondArray.indexOf(tag) <= -1;
    });
};

export const intersection = (
    firstArray: Immutable.List<string>,
    secondArray: Immutable.List<string>
): Immutable.List<string> => {
    return firstArray
        .filter(tag => {
            return secondArray.indexOf(tag) > -1;
        })
        .toSet()
        .toList();
};

export const sumBy = (
    list: Immutable.List<Object>,
    sumKey: string | Array<string>
): number => {
    // doesn't support immutable models yet
    const total = list.reduce((sum, value) => {
        if (_.isString(sumKey)) {
            return sum + value.get(sumKey);
        }
        return sum + value.getIn(sumKey);
    }, 0);
    return total;
};
